<template>
	<div>
		<header-first />
		<section class="ban-course">
			<div class="breadcrumb1"><span class="home-b">Home</span> /<span class="Course-b"> Course  </span></div>
			<h3 class="head-ban-contan1" v-if="this.basicinfo!=''">
        {{basicinfo.course_name}}
      </h3>
			<!-- <div class="diabetology1">
        (RECOGNISED BY RSSDI AND JAIPUR NATIONAL UNIVERSITY)
      </div> -->
		</section>
		<section class="about-the-advantages" v-if="this.basicinfo!=''">
			<div class="row clearfix">
				<div class="col-lg-8" id="content">
					<h2 class="heading-tag">About the Course</h2>
					<p class="about">
            {{basicinfo.course_description}}
          </p>
          <div class="row ">
            <div class="col-md-12">
              <h2 class="heading-tag" v-if="this.units.length > 0">Course Content</h2>
              <div class="card" style="width:100%; height:auto;" v-if="this.units.length > 0">
                  <div class="card-header card-he1">
                    {{basicinfo.course_name}} will Include
                  </div>
                  <div class="card-body bg-gray1">
                    <p class=" mb-0">
                      <ul class="list-redd">
                        <li class="dor" v-for="item in units" :key="item.unit_id">
                          <p>{{ item.unit_name }}</p>
                        </li>
                      </ul>
                    </p>
                  </div>
              </div>
            </div>
          </div>
					<!-- </div> -->
					<!-- advantages -->
					<h2 class="heading-tag" v-if="this.features.length > 0" >Advantages</h2>
					<div class="row container clearfix " style="margin:0px; padding:0px;" v-if="this.features.length > 0" >
						<div>
							<ul class="timeline">
								<li class="event" v-for="item in features" :key="item.id">
									<p>{{ item.feature }}</p>
								</li>
							</ul>
						</div>
					</div>
          <!-- target population (whocanenroll) -->
					<h2 class="heading-tag" v-if="this.whocanenroll.length > 0" >Target Population</h2>
					<div class="row container clearfix " style="margin:0px; padding:0px;" v-if="this.whocanenroll.length > 0" >
						<div>
							<ul class="timeline">
								<li class="event" v-for="item in whocanenroll" :key="item.id">
									<p>{{ item.namegra }}</p>
								</li>
							</ul>
						</div>
					</div>
					<!-- target population (whocanenroll) end -->
					<!-- <h2 class="heading-tag pt-3" v-if="this.outcomes.length > 0" >Learning Outcomes/By end of the course</h2> -->
					<h2 class="heading-tag pt-3" v-if="this.outcomes.length > 0" >Objectives - What is achieved after completion of course(expectation to learn)</h2>
					<div class="row container clearfix " style="margin:0px; padding:0px;" v-if="this.outcomes.length > 0">
						<div>
							<ul class="timeline">
								<li class="event" v-for="item in outcomes" :key="item.id">
									<p>{{ item.co_statement }}</p>
								</li>
							</ul>
						</div>
					</div>
					<div class="row">
						<div class="col-md-12">
							<h2 class="heading-tag">Certificate</h2>
							<p>
                <!-- Earn your eduplusnow and RSSDI Certificate of Completion. Share -->
                Earn your RSSDI Certificate of Completion. Share
                it with the world.
              </p>
							<ul class="timeline">
								<li class="event">
									<p>Build your skills and your career.</p>
								</li>
								<li class="event">
									<p>
                    <!-- Get an industry-recognized certification from eduplusnow. -->
                    Get an industry-recognized certification from RSSDI.
                  </p>
								</li>
								<li class="event">
									<p>Share your accomplishment with the world.</p>
								</li>
							</ul>
						</div>
						<div class="col-md-12">
							<img v-if="this.basicinfo.certificate_link!=null"
                :src="this.basicinfo.certificate_link"
                class="certificate-img"
              />
              <!-- <img v-else
                height="100px;"
                src="https://vgespl-sbpps.s3.ap-south-1.amazonaws.com/logo/logo-rssdi.png"
                class="certificate-img"
              /> -->
						</div>
					</div>
				</div>
				<div class="col-lg-3">
					<vue-sticky-sidebar
            class="sidebar"
            topSpacing="70"
            containerSelector=".container"
            innerWrapperSelector=".sidebar__inner"
          >
						<!-- <get-user-info :course_fees="course_fees" /> -->
						<!-- <get-user-info :course_fees="course_fees" :totalResources="totalResources" :videoDuration="videoDuration"/> -->
            <!-- <p>in rssdi sign up</p> -->
						<rssdi-sign-up v-if="course_fees != null && course_fees != 0" :course_fees="course_fees" :totalResources="totalResources" :videoDuration="videoDuration" :crs_id="crs_id"/>
					</vue-sticky-sidebar>
					<!-- mobile view -->
					<!-- <get-user-info class="class-mob" :course_fees="course_fees" /> -->
					<rssdi-sign-up v-if="course_fees != null && course_fees != 0" class="class-mob" :totalResources="totalResources" :videoDuration="videoDuration" :course_fees="course_fees" :crs_id="crs_id"/>
					<!-- mobile view -->
				</div>
			</div>
		</section>
		<!-- <section class="contact-rssdi">
			<div class="row">
				<div class="col-sm-6">
					<h2 class="heading-tag">Contact</h2>
					<h4>Dr Sanjay Agarwal's Aegle Clinic for Diabetes Care</h4>
					<p>
            A-11, Narsimha Housing Society
						
						<br />
            194, Boat Club Road Pune- 411001 ( India )
          
					
					</p>
				</div>
				<div class="col-sm-3">
					<h2 class="dis-b-m">
						<br />
					</h2>
					<h4>Phone</h4>
					<p>020-2616003, 
						
						<br />8237730003, 9823133669
					
					</p>
				</div>
				<div class="col-sm-3">
					<h2 class="dis-b-m">
						<br />
					</h2>
					<h4>Email</h4>
					<h6>rssdihq@gmail.com</h6>
				</div>
			</div>
		</section> -->
		<footer-first />
	</div>
</template>
<script>
import axios from "axios";
import "@/assets/css/rssdi.css";
import RssdiSignUp from "@/components/Rssdi/RssdiSignUp.vue";
import getUserInfo from "@/components/Rssdi/getUserInfo.vue";
import footer from "@/components/Rssdi/layout/footersecond.vue";
import header from "@/components/Rssdi/layout/header.vue";
import vueStickySidebar from "vue-sticky-sidebar";
export default {
  components: {
    "rssdi-sign-up": RssdiSignUp,
    "get-user-info": getUserInfo,
    "footer-first": footer,
    "header-first": header,
    "vue-sticky-sidebar": vueStickySidebar,
  },
  data: () => ({
    crs_id: null,
    tenantid: null,
    course_list: [],
    basepath: null,
    unit_level: null,
    course_fees: "",
    id: null,
    prerequisites: "",
    whocanenroll: "",
    basicinfo: [],
    features: [],
    units: [],
    outcomes: [],
    totalResources: "",
    videoDuration: "",
    // groupedProps:{}
  }),
  created() {
    this.basepath = this.$session.get("path");
  },
  mounted() {
    // this.onLoad();
    document.title = "RESEARCH SOCIETY FOR THE STUDY OF DIABETES IN INDIA";
        document.title = "RESEARCH SOCIETY FOR THE STUDY OF DIABETES IN INDIA";
     var link = document.getElementById ("page-title-image");
    link.href = "https://rssdilivebucket.s3.ap-south-1.amazonaws.com/rssdi/rssdi-title-page.jpeg"
    localStorage.setItem("platform","rssdi")
    console.log("ID", this.$router);
    console.log("ID", this.$route.params);
    this.id = this.$route.params.id;
    this.getCourseDetails(this.id);
  },
  methods: {
    getCourseDetails(id) {
      let data = {
        staticlink: id,
        tenantid: "rssdi", //'common',
      };
      //axios.defaults.baseURL = process.env.VUE_APP_API_URL_Inst;
      axios.defaults.baseURL = process.env.VUE_APP_API_URL_Home;
      axios
        .post("/Rssdi/getCourseInfo", data)
        .then((res) => {
          // console.log("res", res);
          // console.log("res.data", res.data);
          if (res.data.flag == "Yes") {
            console.log("success...");
            //set data from back-end
            this.basicinfo = res.data.basicinfo;
            this.features = res.data.features;
            this.whocanenroll = res.data.whocanenroll;
            this.units = res.data.units;
            this.outcomes = res.data.outcomes;
            this.videoDuration = res.data.videoDuration;
            this.crs_id = res.data.basicinfo.course_id
            // console.log("this.videoDuration")
            // console.log(this.videoDuration)
            if(this.videoDuration.includes("0 hr 0 min 0 sec")){
              this.videoDuration = "-"
            }else{}
            this.totalResources = res.data.totalResources;
            this.course_fees = res.data.courseFees;
          } else {
            console.log("error");
            this.showsnackbar(res.data.snackbar, "error", 5000);
          }
        })
        .catch((error) => {
          console.log("Err", error);
          // this.onerror(error);
        })
        .finally(() => {
          console.log("Error");
        });
    },
    showsnackbar(msg, color, to) {
      this.$store.dispatch("setSnackbar", {
        showing: true,
        timeout: to,
        color: color,
        text: msg,
      });
    },
    home() {
      // this.$router.push({ name: "signup" });
      this.$router.push({ name: "rssdi-home" });
      return;
    },
    signup() {
      // this.$router.push({ name: "signup" });
      this.$router.push({ name: "rssdi-login" });
      return;
    },
    login() {
      this.$router.push({ name: "rssdi-login" });
    },
    coursesrssdi() {
      this.$router.push({ name: "course" });
    },
    home() {
      this.$router.push({ name: "rssdi-home" });
    },
    about() {
      this.$router.push({ name: "aboutus" });
    },
    contact() {
      this.$router.push({ name: "contact" });
    },
    news_media() {
      this.$router.push({ name: "news_media" });
    },
    content() {
      const el = this.$el.getElementsByClassName("course-content")[0];
      if (el) {
        // Use el.scrollIntoView() to instantly scroll to the element
        el.scrollIntoView({ behavior: "smooth" });
      }
    },
    assessments() {
      const el = this.$el.getElementsByClassName("assessments")[0];
      if (el) {
        // Use el.scrollIntoView() to instantly scroll to the element
        el.scrollIntoView({ behavior: "smooth" });
      }
    },
    // onLoad() {
    //   this.crs_id = this.$route.params.crs_id;
    //   this.tenantid = this.$route.params.tenantid;
    //   const data = {
    //     crs_id: this.crs_id,
    //     tenantid: this.tenantid,
    //   };
    //   axios
    //     .post("/Rssdi/courseInfo", data)
    //     .then((res) => {
    //       if (res.data.flag == "Yes") {
    //         this.course_list = res.data.course_information;
    //         this.unit_level = res.data.unit_level;
    //       } else {
    //         this.showsnackbar("Something went wrong!", "error", 5000);
    //       }
    //     })
    //     .catch((error) => {
    //       let msg = "";
    //       if (error.response) {
    //         msg = "Something went wrong.";
    //       } else if (error.request) {
    //         msg = "Please try again111.";
    //       } else {
    //         msg = "Un-expected error111.";
    //       }
    //       this.$store.dispatch("setSnackbar", {
    //         showing: true,
    //         timeout: 5000,
    //         color: "error",
    //         text: msg,
    //       });
    //     })
    //     .finally(() => {
    //       this.overlay = false;
    //     });
    // },
  },
};
</script>
<style scoped>
.about {
  text-align: justify;
  text-justify: inter-word;
}
.box {
  /* background-color: #c9d8dd59; */
  margin: 8px !important;
  padding: 8px;
  border: 2px solid rgb(195, 214, 218) !important;
}
.toolbar {
  text-align: center !important;
  background-color: #424093 !important;
  color: #ffffff !important;
}
.button {
  border: 2px solid #424093 !important;
  color: #424093;
  background: transparent !important;
  border-radius: 50px;
  margin: 0.5rem !important;
}
.button:hover {
  color: white;
  background: #424093 !important;
}
.crs-name {
  padding: 2rem 0rem 0rem 3rem;
}
@media only screen and (max-width: 600px) {
  .crs-name {
    padding: 2rem 2rem 0rem 3rem;
  }

  .p-0 {
    padding: 0;
  }
}
.info-title {
  font-weight: bold;
  font-size: 15px;
  color: black;
}
.input-group input {
  border-width: 1px;
  border-top-left-radius: 15px !important;
  border-top-right-radius: 15px !important;
}
.input-group-addon i {
  position: relative;
  top: 8px;
  right: 8px;
  color: #424093;
}
.heading-tag:after {
  background: none;
}
.home-b{
font-weight:bold;}
</style>
